import { createReducer, on } from '@ngrx/store';
import { moduleActions } from '../actions/module.actions';
import { Module } from '../models';

export interface ModuleState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    module: Module | null;
}

export const initialState: ModuleState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    module: null,
};

export const moduleReducer = createReducer(
    initialState,
    // Get
    on(
        moduleActions.getModule,
        (state): ModuleState => ({
            ...state,
            loading: true,
            loaded: null,
            error: null,
        }),
    ),
    on(
        moduleActions.getModuleSuccess,
        (state, { payload }): ModuleState => ({
            ...state,
            loading: false,
            loaded: true,
            error: null,
            module: payload,
        }),
    ),
    on(
        moduleActions.getModuleError,
        (state, payload): ModuleState => ({
            ...state,
            loading: false,
            loaded: false,
            error: payload.code,
        }),
    ),
    // Create
    on(
        moduleActions.createModule,
        (state): ModuleState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        moduleActions.createModuleSuccess,
        (state, { payload }): ModuleState => ({
            ...state,
            saving: false,
            saved: true,
            module: payload,
        }),
    ),
    on(
        moduleActions.createModuleError,
        (state): ModuleState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Update
    on(
        moduleActions.updateModule,
        (state): ModuleState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        moduleActions.updateModuleSuccess,
        (state, { payload }): ModuleState => ({
            ...state,
            saving: false,
            saved: true,
            module: payload,
        }),
    ),
    on(
        moduleActions.updateModuleError,
        (state): ModuleState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Delete
    on(
        moduleActions.deleteModule,
        (state): ModuleState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        moduleActions.deleteModuleSuccess,
        (state): ModuleState => ({
            ...state,
            saving: false,
            saved: true,
            module: null,
        }),
    ),
    on(
        moduleActions.deleteModuleError,
        (state): ModuleState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Clear
    on(moduleActions.clear, (): ModuleState => ({ ...initialState })),
);
